import { useEffect, useState } from "react";
import HelpSupport from "../HelpSupport/HelpSupport";
import styles from "./Success.module.scss";

const DEFAULT_EVENT_DATE = "2026-11-08T14:00:00-03:00";

function calculateRemaining(targetDate) {
  const difference = Math.max(0, new Date(targetDate).getTime() - Date.now());
  return {
    days: Math.floor(difference / 86_400_000),
    hours: Math.floor((difference / 3_600_000) % 24),
    minutes: Math.floor((difference / 60_000) % 60),
  };
}

function Success({ onBack }) {
  const eventDate = import.meta.env.VITE_EVENT_DATE || DEFAULT_EVENT_DATE;
  const [remaining, setRemaining] = useState(() => calculateRemaining(eventDate));

  useEffect(() => {
    const updateRemaining = () => setRemaining(calculateRemaining(eventDate));
    updateRemaining();
    const timer = window.setInterval(updateRemaining, 60_000);
    return () => window.clearInterval(timer);
  }, [eventDate]);

  const { days = 0, hours = 0, minutes = 0 } = remaining;

  return (
    <section className={styles.success}>
      <div className={styles.layout}>
        <header className={styles.heading}>
          <h1 id="success-title" tabIndex="-1">Cadastro concluído com sucesso!</h1>
          <p><strong>Obrigado!</strong><br />Recebemos suas informações.<br />Em breve enviaremos os detalhes da sua participação.</p>
        </header>

        <div className={styles.card}>
          <div className={styles.countdown} aria-label={`${days} dias, ${hours} horas e ${minutes} minutos`}>
            <h2>Faltam</h2>
            <div className={styles.values} aria-hidden="true">
              <TimeValue value={days} label="Dias" />
              <TimeValue value={hours} label="Horas" />
              <TimeValue value={minutes} label="Minutos" />
            </div>
            <p>Para acelerar no Grande Prêmio de São Paulo.</p>
          </div>
          <HelpSupport showContact />
          <button className={styles.backButton} type="button" onClick={onBack}>Voltar</button>
        </div>
      </div>
    </section>
  );
}

function TimeValue({ value, label }) {
  return (
    <div>
      <strong>{String(value).padStart(2, "0")}</strong>
      <span>{label}</span>
    </div>
  );
}

export default Success;
